/* istanbul ignore file */
import React, { useState } from 'react';
import { CreateForm } from 'framework/form';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import PresaleRequestForm from 'domain/sales/opportunity/presale/request/form/PresaleRequestForm';
import usePresaleOpportunityService from 'domain/sales/opportunity/presale/request/shared/presaleRequestService';
import BeforeSubmitModal from 'domain/sales/opportunity/presale/request/shared/modal/BeforeSubmitModal';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';

const CreatePresaleRequestForm = ({ submitFormFunc, onCancel, ...props }: any) => {
  const { getValidationSchema } = usePresaleOpportunityService();
  const [modalOpen, setModalOpen] = useState(false);

  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  return (
    <CreateForm
      submitFormFunc={async data => {
        const artifactPath = data?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.PRESALE_REQUEST_DOCUMENT);
        return submitFormFunc({ ...data, artifactPaths: commitData });
      }}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <CreateTimelineItemLayout onSubmitAction={() => setModalOpen(true)} onCancel={onCancel}>
        <BeforeSubmitModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
        <PresaleRequestForm isCreateForm />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreatePresaleRequestForm;
